(()=>{if(document.querySelector('[data-alv-main]'))customElements.whenDefined('slideshow-component').then(()=>document.querySelectorAll('slideshow-component.announcement-bar').forEach(component=>{if(typeof component.pause==='function')component.pause()}));const init=root=>{if(root.dataset.alvReady)return;root.dataset.alvReady='true';const track=root.querySelector('.alv-korean-track'),thumbs=[...root.querySelectorAll('[data-slide]')];if(!track)return;const slides=[...track.children];thumbs.forEach((button,index)=>button.addEventListener('click',()=>track.scrollTo({left:index*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));let frame;track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{const current=Math.round(track.scrollLeft/Math.max(track.clientWidth,1));thumbs.forEach((button,index)=>{if(index===current)button.setAttribute('aria-current','true');else button.removeAttribute('aria-current');if(Math.abs(index-current)<=1)slides[index]?.querySelector('img')?.setAttribute('loading','eager')})})},{passive:true})};document.querySelectorAll('[data-alv-main]').forEach(init);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-alv-main]').forEach(init))})();

(() => {
  if (!document.querySelector('[data-alv-main]')) return;
  const quantities = [2, 4, 8];
  const names = ["Na vyzkoušení", "Kompletní rutina", "Pro celou rodinu"];
  const format = new Intl.NumberFormat('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  let observer;
  let scheduled = false;

  function apply() {
    scheduled = false;
    const moon = document.querySelector('moonbundle-component');
    if (!moon) return;
    const heading = moon.querySelector('.moonbundle-title');
    if (heading && heading.textContent.trim() !== 'VYBERTE SI BALENÍ') {
      heading.textContent = 'VYBERTE SI BALENÍ';
    }
    const cards = moon.querySelectorAll('.moonbundle-option-wrapper');
    if (cards.length !== 3) return;
    cards.forEach((card, i) => {
      const col = card.querySelector('.moonbundle-option-col-inner');
      const price = card.querySelector('.moonbundle-option-price');
      const pack = card.querySelector('.moonbundle-option-single-price');
      if (!col || !price || !pack) return;
      let name = col.querySelector('.alv-korean-cz-season');
      if (!name) {
        name = document.createElement('span');
        name.className = 'alv-korean-cz-season';
        col.prepend(name);
      }
      if (name.textContent !== names[i]) name.textContent = names[i];
      const raw = (pack.textContent.match(/[\d.,\s\u00a0]+/) || [''])[0].replace(/[\s\u00a0.]/g, '').replace(',', '.');
      const total = Number(raw);
      if (!Number.isFinite(total) || total <= 0) return;
      const expected = `${format.format(total / quantities[i])} Kč`;
      if (pack.dataset.unit !== expected) pack.dataset.unit = expected;
      const displayTotal = pack.textContent.trim();
      if (pack.dataset.total !== displayTotal) pack.dataset.total = displayTotal;
      price.setAttribute('aria-label', `${expected} za šampon, celkem ${displayTotal}`);
    });
    const urgency = document.querySelector('.alv-korean-urgency');
    if (urgency && moon.nextElementSibling !== urgency) moon.after(urgency);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(apply);
  }

  function init() {
    const moon = document.querySelector('moonbundle-component');
    if (moon) {
    schedule();
    observer = new MutationObserver(schedule);
    observer.observe(moon, { childList: true, subtree: true });
    moon.addEventListener('click', () => setTimeout(schedule, 0));
    setTimeout(schedule, 300);
    setTimeout(schedule, 1200);
    }
    const clock = document.querySelector('.alv-korean-cz-count');
    if (clock) {
      const tick = () => {
        const now = new Date();
        const end = new Date(now);
        end.setHours(23, 59, 59, 999);
        const seconds = Math.max(0, Math.floor((end - now) / 1000));
        const two = n => String(n).padStart(2, '0');
        clock.textContent = `${two(Math.floor(seconds / 3600))}:${two(Math.floor((seconds % 3600) / 60))}:${two(seconds % 60)}`;
      };
      tick();
      setInterval(tick, 1000);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
